export default __webpack_public_path__ + "static/media/sunlit_swamp.974c5469.svg";